























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MonitoringTrombolisisSvc from "@/services/MonitoringTrombolisisService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { storePerawat } from "@/store/modules/perawat";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";

@Component({
  components: {
    PersonAutoComplete,
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class MonitoringTrombolisisSetup extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) monitoring!: any;
  @Prop({ default: false }) readonly!: boolean;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = true;
  saving = false;

  form: any = {
    register_id: "",
    pasien_rm: "",
    unit_id: "",
    diagnosis: "STROKE ISKEMIK",
    onset_at: "",
    arrival_at: "",
    nihss_pre_tpa: null,
    berat_badan: null,
    bolus_at: "",
    infus_started_at: "",
    infus_ended_at: "",
    dpjp_id: null,
    perawat_id: null,
    kontraindikasi: [],
  };

  rules = {
    required: (v: any) => !!v || "Wajib diisi",
    bbRange: (v: any) => (v >= 1 && v <= 300) || "BB harus antara 1-300 kg",
  };

  mounted() {
    // Ensure person list is loaded for PersonAutoComplete
    if (!storePerawat.listPerawat || storePerawat.listPerawat.length === 0) {
      storePerawat.actListPerawatall();
    }

    if (this.monitoring) {
      this.populateForm();
    } else {
      this.form.register_id = this.register;
      this.form.pasien_rm = this.rm;
      this.form.unit_id = userModule.user?.unit_id || "";
    }
  }

  @Watch("monitoring")
  onMonitoringChange() {
    if (this.monitoring) {
      this.populateForm();
    }
  }

  get isNew() {
    return !this.monitoring || !this.monitoring.id;
  }

  get dpjpSigned(): boolean {
    return !!this.monitoring?.dpjp_signed_at;
  }

  get perawatSigned(): boolean {
    return !!this.monitoring?.perawat_signed_at;
  }

  get dosisTotal() {
    if (!this.form.berat_badan) return "-";
    return Math.min(this.form.berat_badan * 0.9, 90).toFixed(2);
  }

  get dosisBolus() {
    if (!this.form.berat_badan) return "-";
    return (parseFloat(this.dosisTotal) * 0.1).toFixed(2);
  }

  get dosisInfus() {
    if (!this.form.berat_badan) return "-";
    return (parseFloat(this.dosisTotal) * 0.9).toFixed(2);
  }

  computeDosis() {
    // Reactivity is handled by computed properties
  }

  populateForm() {
    const m = this.monitoring;
    this.form = {
      register_id: m.register_id,
      pasien_rm: m.pasien_rm,
      unit_id: m.unit_id,
      diagnosis: m.diagnosis,
      onset_at: this.toDatetimeLocal(m.onset_at),
      arrival_at: this.toDatetimeLocal(m.arrival_at),
      nihss_pre_tpa: m.nihss_pre_tpa,
      berat_badan: parseFloat(m.berat_badan),
      bolus_at: this.toDatetimeLocal(m.bolus_at),
      infus_started_at: this.toDatetimeLocal(m.infus_started_at),
      infus_ended_at: this.toDatetimeLocal(m.infus_ended_at),
      dpjp_id: m.dpjp_id,
      perawat_id: m.perawat_id,
      kontraindikasi: m.kontraindikasi || [],
    };
  }

  toDatetimeLocal(dt: string | null) {
    if (!dt) return "";
    return dt.substring(0, 16);
  }

  async simpan() {
    if (this.readOnly) return;
    const formRef = this.$refs.form as any;
    if (!formRef.validate()) return;

    this.saving = true;
    try {
      let resp;
      if (this.isNew) {
        resp = await MonitoringTrombolisisSvc.create(this.form);
      } else {
        resp = await MonitoringTrombolisisSvc.update(this.monitoring.id, this.form);
      }

      if (resp?.data?.status == "1") {
        appModule.NoticeDelay(this.isNew ? "Monitoring berhasil dibuat" : "Berhasil disimpan");
        this.$emit("saved", resp.data.data);
      }
    } catch {
      // handled by service
    }
    this.saving = false;
  }
}
